import type { offline as EN } from '../en/offline';

export const offline: Record<keyof typeof EN, string> = {
  'offline.synced': 'Alle Änderungen synchronisiert.',
  'offline.syncFailed':
    'Einige Änderungen konnten nicht gespeichert werden. Sie werden erneut versucht.',
  'offline.paused': 'Synchronisierung pausiert. Melde dich an, um fortzufahren.',
  'offline.restoredToTop':
    'Auf die oberste Ebene wiederhergestellt, weil das übergeordnete Element noch im Papierkorb ist.',
  'offline.deletedPermanently.one': '{count} Seite endgültig gelöscht.',
  'offline.deletedPermanently.other': '{count} Seiten endgültig gelöscht.',
  'offline.pageChangedElsewhere':
    'Diese Seite wurde anderswo geändert. Deine Version ist sicher — wähle aus, welche behalten werden soll.',
  'offline.fixEventAndSave': 'Korrigiere das Ereignis und speichere erneut.',
  'offline.settingSaveFailed': 'Diese Einstellung konnte nicht gespeichert werden.',
  'offline.pageMoveConflict': 'Eine Seite kann nicht in sich selbst verschoben werden.',
  'offline.syncChangeFailed': 'Eine Änderung konnte nicht synchronisiert werden: {message}',
  'offline.syncChangeFailedHint':
    'Sie ist weiterhin auf diesem Gerät gespeichert. Öffne das Sync-Menü, um es erneut zu versuchen.',
};
